import React, { createContext, useReducer, useCallback, useEffect } from 'react'

const key_storage = 'upselling'

export const init_uppseling_context_value: IFeatureFlag = {
    reports: false,
    amimarket: false,
    cart_f2f: false,
    bottomBar: {
        orders: false,
        inventory: false,
        sales: false,
    },
    drawer: {
        promotions: false,
        userBankData: false,
        chat: false,
        config: {
            eco_friendly: false,
        },
        billingPayments: false,
    },
    delivery: false,
    terminal: {
        bci: false,
        getnetc2c: false,
    },
    settlement: false,
    marketplace: false,
    cashPayment: false,
    sales_report: false,
    posManual: false,
    pos_payment: false,
}

export const UpsellingContext = createContext({
    upselling: init_uppseling_context_value,
    updateUpselling: (path: string, value: boolean): void => {
        console.log(path, value)
    },
    resetUpselling: (): void => {
        console.log
    },
})

function statusReducer(
    upselling: IFeatureFlag,
    action: { type: string; payload?: IFeatureFlag }
) {
    switch (action.type) {
        case 'update':
            return {
                ...upselling,
                ...action.payload,
            }
        case 'reset':
            return init_uppseling_context_value
        default:
            return upselling
    }
}

export function UpsellingProvider({
    children,
}: {
    children: JSX.Element[] | JSX.Element
}) {
    const [upselling, dispatch] = useReducer(
        statusReducer,
        init_uppseling_context_value
    )

    function saveStorage(object: IFeatureFlag) {
        localStorage.setItem(key_storage, JSON.stringify(object))
    }

    useEffect(() => {
        const data = localStorage.getItem(key_storage)
        if (data) {
            dispatch({
                type: 'update',
                payload: JSON.parse(data),
            })
        } else {
            console.log(upselling)
            saveStorage(upselling)
        }
    }, [])

    function updateKey(
        obj: IFeatureFlag,
        path: string,
        value: boolean
    ): IFeatureFlag {
        const keys = path.split('.')
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let current: any = obj

        for (let i = 0; i < keys.length - 1; i++) {
            if (!current[keys[i]]) {
                throw new Error(`La clave ${keys[i]} no existe en el objeto`)
            }
            current = current[keys[i]]
        }

        const lastKey = keys[keys.length - 1]
        if (current[lastKey] !== undefined) {
            current[lastKey] = value
        } else {
            throw new Error(`La clave ${lastKey} no existe en el objeto`)
        }

        return obj
    }

    const updateUpselling = useCallback((path: string, value: boolean) => {
        const newUpselling = updateKey(upselling, path, value)

        dispatch({
            type: 'update',
            payload: newUpselling,
        })

        saveStorage(newUpselling)
    }, [])

    const resetUpselling = useCallback(() => {
        dispatch({ type: 'reset' })
    }, [])

    return (
        <UpsellingContext.Provider
            value={{ upselling, updateUpselling, resetUpselling }}
        >
            {children}
        </UpsellingContext.Provider>
    )
}
